<template>
    <div v-if="visible" class="d11-shadow" @click.self="$emit('close')">
        <div class="d11-success-dialog">
            <img src="~@/assets/newHome/关闭.png" alt="" class="d11-dialog-close" @click="$emit('close')" />
            <div class="d11-success-head">
                <span class="d11-success-icon">
                    <span class="d11-success-check">✓</span>
                </span>
                <span class="d11-success-title">领取成功！</span>
            </div>
            <div class="d11-success-desc">已成功发放10000次高级流量，流量有效期自领取之日起 2 个月</div>
            <div class="d11-success-sub">可前往"在线地图访问-图源管理"查看使用情况</div>
            <div class="d11-success-buttons">
                <div class="d11-btn-cancel" @click="$emit('close')">暂不前往</div>
                <div class="d11-btn-confirm" @click="onGo">立即前往</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Double11SuccessDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onGo() {
            this.$router.push({ path: '/rsManage', hash: '#source-list-section' }).catch(() => {})
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.d11-shadow {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 12000;
}
.d11-success-dialog {
    position: absolute;
    width: 516px;
    height: auto;
    padding: 40px 40px 36px;
    border-radius: 8px;
    left: calc(50% - 258px);
    top: calc(50% - 155px);
    z-index: 12001;
    background: #ffffff;
    box-sizing: border-box;
}
.d11-dialog-close {
    position: absolute;
    top: 0;
    right: -50px;
    cursor: pointer;
}
.d11-success-head {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}
.d11-success-icon {
    width: 30px;
    height: 30px;
    background: #52C41A;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.d11-success-check {
    color: #ffffff;
    font-size: 18px;
    font-weight: bold;
    line-height: 1;
}
.d11-success-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 22px;
    color: #1F1F1F;
    line-height: 30px;
}
.d11-success-desc {
    width: 100%;
    margin-top: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    line-height: 28px;
    text-align: center;
}
.d11-success-sub {
    width: 100%;
    margin-top: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #8C8C8C;
    line-height: 22px;
    text-align: center;
}
.d11-success-buttons {
    width: 100%;
    margin-top: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 56px;
}
.d11-btn-cancel {
    width: 120px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #D9D9D9;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 34px;
    text-align: center;
    cursor: pointer;
    background: #ffffff;
}
.d11-btn-cancel:hover {
    border-color: #40A9FF;
    color: #40A9FF;
}
.d11-btn-confirm {
    width: 120px;
    height: 36px;
    border-radius: 4px;
    background: #1890FF;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
}
.d11-btn-confirm:hover {
    background: #40A9FF;
}
</style>
